import React              from 'react';
import Sidebar            from './../../components/sidebar';
import screenInstance     from './../search';
import {Divider,MenuItem} from 'material-ui';
import AppState           from './../../state/app';
import searchFilter       from '../../const/search'
import sidebarState       from './../../state/sidebar';
import {withRouter}       from 'react-router-dom';

class SearchSidebar extends Sidebar.Sidebar {

    setExpositions = () => {
        sidebarState.close()
        .then(() => {
            AppState.setSearchIn(searchFilter.SEARCH_IN.EXPOSITIONS);
        })
    }

    setPlants = () => {
        sidebarState.close()
        .then(() => {
            AppState.setSearchIn(searchFilter.SEARCH_IN.PLANTS);
        })
    }

    getMenuItemComponent(screen) {
        let menuItem = super.getMenuItemComponent(screen);
        if (screen.code !== screenInstance.code) {
            return menuItem;
        }
        //TODO: improve this
        let extendedMenu = [
            <Divider key={6}/>,
            menuItem,
            <Divider key={7}/>,
            <MenuItem key={0} onClick={this.setPlants} primaryText="Rostliny" insetChildren={true}/>,
            <MenuItem key={1} primaryText="Zvířata" insetChildren={true}/>,
            <MenuItem key={2} onClick={this.setExpositions} primaryText="Expozice" insetChildren={true}/>,
            <MenuItem key={3} primaryText="Okruhy" insetChildren={true}/>,
            <MenuItem key={4} primaryText="Události" insetChildren={true}/>,
            <MenuItem key={5} primaryText="Články" insetChildren={true}/>,
            <Divider key={8}/>
        ];
        return extendedMenu;
    }
}

export default withRouter((props) => {
    return <SearchSidebar {...props}/>
})


// WEBPACK FOOTER //
// ./src/screens/search/sidebar.js